import Image from 'next/image';
import Experiment from '@/components/analytics/experiments/experiment';
import { cn } from '@discover-lib/utils';
import { PD6665_NEW_USER_DISCOUNT_FLAG } from './flag';

export type PD6665VoucherImageProps = {
  currency: string;
};

function voucherSrc(currency: string, prefix: '' | 'pd6665-') {
  switch (currency) {
    case 'GBP':
      return `/images/${prefix}voucher-exit-modal-pound.svg`;
    case 'EUR':
      return `/images/${prefix}voucher-exit-modal-euro.svg`;
    default:
      return `/images/${prefix}voucher-exit-modal-dollar.svg`;
  }
}

function CurrencyVoucherImage({
  width,
  height,
  isTreatment,
  currency,
}: {
  width: number;
  height: number;
  isTreatment: boolean;
  currency: string;
}) {
  const src = isTreatment ? voucherSrc(currency, 'pd6665-') : voucherSrc(currency, '');
  return (
    <Image
      alt=""
      aria-hidden
      className={cn('mx-auto h-auto w-full', isTreatment && 'rounded-2xl')}
      height={height}
      src={src}
      width={width}
    />
  );
}

export default function PD6665VoucherImage({ currency }: PD6665VoucherImageProps) {
  return (
    <Experiment
      flag={PD6665_NEW_USER_DISCOUNT_FLAG}
      control={
        <CurrencyVoucherImage currency={currency} width={371} height={220} isTreatment={false} />
      }
      treatment={<CurrencyVoucherImage currency={currency} width={415} height={203} isTreatment />}
    />
  );
}
